import { Component, OnInit, Input } from '@angular/core';
import { PostAttachments } from 'src/app/_models';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FilesService } from 'src/app/_services';
import { BaseComponent } from 'src/app/_base/base.component';

@Component({
  selector: 'app-post-files-viewer',
  templateUrl: './post-files-viewer.component.html',
  styleUrls: ['./post-files-viewer.component.scss']
})
export class PostFilesViewerComponent extends BaseComponent implements OnInit {
  @Input()
  postFiles: PostAttachments[] = [];
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    suppressScrollY: true
  };
  constructor(private filesService: FilesService) {
    super();
  }

  ngOnInit() {}
  getFileImage(fileMimeType: string): string {
    return this.filesService.fileMimeTypeChecker(fileMimeType).iconUrl;
  }
  downloadAttachment(attachmentFileName: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = this.getImage(attachmentFileName);
    a.target = '_blank';
    a.download = attachmentFileName;
    a.click();
    document.body.removeChild(a);
  }
}
